import ActionTypes from '@utils/deviceActions';
import { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { IDevice } from '@pages/Assets/Inventory/types';

interface ForceReactivationPayloadProps {
  action: ActionTypes.FORCE_REACTIVATION;
  devices: {
    msisdn: string;
  }[];
}

interface ForceReactivationProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useForceReactivation = ({
  devices,
  isUpload,
}: ForceReactivationProps): DeviceActionProps => {
  const payloadToSend = useMemo(
    (): ForceReactivationPayloadProps => ({
      action: ActionTypes.FORCE_REACTIVATION,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
  };
};

export default useForceReactivation;
